<template>
  <div class="banner-item">
    <form-container :hasData="true" :manual="true">
      <template #heading>
        <h1>Баннер на главной</h1>
      </template>
      <template #content>
        <banner-form v-if="model" :model="model" @imageUpdated="imageUpdated"/>
      </template>
    </form-container>
  </div>
</template>

<script>
import options from '@/config/dropzone-options';

import BannerModel from '@/models/banner';

import BannerForm from './BannerForm';
import FormContainer from '@/components/common/FormContainer.vue';

export default {
  name: 'banner-item',

  components: {
    FormContainer,
    BannerForm,
  },

  methods: {
    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
    },

    imageUpdated(url) {
      this.model.image_url = null;
      this.$nextTick(() => (this.model.image_url = url + "?updated=" + Date.now()));
      this.toast('Изображение обновлено.', 'success');
    },
  },

  data() {
    return {
      model: null,
    };
  },

  created() {
    this.model = new BannerModel(this.banner);
  },
};
</script>

<style lang="scss" scoped>
.banner-item {
  flex: 1;
}
</style>
